import { removeClassStyleAttrs as e } from "../../common/utils/index.js";
import { t } from "../../_plugin-vue_export-helper-BTgDAbhb.js";
import { MUTED as n } from "../link/link-constants.js";
import r from "../link/link.js";
import { BREADCRUMB_ITEM_SELECTED_MODIFIER as i } from "./breadcrumbs-constants.js";
import { createElementBlock as a, createTextVNode as o, createVNode as s, mergeProps as c, normalizeClass as l, normalizeStyle as u, openBlock as d, renderSlot as f, resolveComponent as p, toDisplayString as m, withCtx as h } from "vue";
//#region components/breadcrumbs/breadcrumb_item.vue
var g = {
	name: "DtBreadcrumbItem",
	components: { DtLink: r },
	inheritAttrs: !1,
	props: {
		inverted: {
			type: Boolean,
			default: !1
		},
		selected: {
			type: Boolean,
			default: !1
		},
		label: {
			type: String,
			default: ""
		}
	},
	data() {
		return { BREADCRUMB_ITEM_SELECTED_MODIFIER: i };
	},
	computed: {
		linkKind() {
			return this.inverted ? "" : n;
		},
		linkInverted() {
			return !!this.inverted;
		},
		ariaCurrent() {
			return this.selected ? "location" : void 0;
		}
	},
	methods: { removeClassStyleAttrs: e }
};
function _(e, t, n, r, i, g) {
	let _ = p("dt-link");
	return d(), a("li", {
		"data-qa": "dt-breadcrumb-item",
		class: l([
			"d-breadcrumbs__item",
			{ [i.BREADCRUMB_ITEM_SELECTED_MODIFIER]: n.selected },
			e.$attrs.class
		]),
		style: u(e.$attrs.style)
	}, [s(_, c({
		kind: g.linkKind,
		inverted: g.linkInverted,
		"aria-current": g.ariaCurrent,
		underline: !1,
		"data-qa": "breadcrumb-item"
	}, g.removeClassStyleAttrs(e.$attrs), { class: ["d-breadcrumbs__link"] }), {
		default: h(() => [f(e.$slots, "default", {}, () => [o(m(n.label), 1)])]),
		_: 3
	}, 16, [
		"kind",
		"inverted",
		"aria-current"
	])], 6);
}
var v = /* @__PURE__ */ t(g, [["render", _]]);
//#endregion
export { v as default };

//# sourceMappingURL=breadcrumb-item.js.map